import fetchWithTimeout from './fetchAPI';

export async function requestImpersonationSession(tenantId) {
    const body = {tenantId: tenantId}
    const headers = new Headers();
    headers.append('Content-Type', 'application/json');
    const results = await fetchWithTimeout('impersonate',
        {method: 'POST',
            headers,
            body: JSON.stringify(mapRequest(body)),
            cache: 'no-cache',
            redirect: 'follow',
            credentials: 'omit'
            }, 5000);

    const jsonResults = await results.json();
    return (mapResponse(jsonResults));
}

export async function getSession(token) {
    const headers = new Headers();
    headers.append('token', token);
    const results = await fetchWithTimeout('context',
        {method: 'GET',
            headers: headers,
            cache: 'no-cache',
            redirect: 'follow',
            credentials: 'omit'
        }, 3000);

    const jsonResults = await results.json();
    return (jsonResults);
}

export async function searchTransactions(token, criteria) {
    const headers = new Headers();
    headers.append('token', token);
    const queryString = Object.keys(criteria).map(key => key + '=' + criteria[key]).join('&');
    const results = await fetchWithTimeout('transactions?' + queryString,
        {method: 'GET',
            headers: headers,
            cache: 'no-cache',
            redirect: 'follow',
            credentials: 'omit'
        }, 3000);

    const jsonResults = await results.json();
    return (jsonResults);
}

export async function getReceipt(token, sessionId) {
    const headers = new Headers();
    headers.append('token', token);
    const results = await fetchWithTimeout('receipt/' + sessionId,
        {method: 'GET',
            headers: headers,
            cache: 'no-cache',
            redirect: 'follow',
            credentials: 'omit'
        }, 3000);

    const jsonResults = await results.json();
    return (jsonResults);
}

function mapRequest(body){
    let request = {...body};
    if (body.clientId)
        request.client_id = body.clientId;
    if (body.sessionId)
        request.session_id = body.sessionId;
    if (body.tenantId)
        request.tenant_id = body.tenantId;
    if (body.userId)
        request.user_id = body.userId;
    return request;
}
function mapResponse(body){
    let response = {...body};
    if (body.session_id)
        response.sessionId = body.session_id;
    if (body.tenant_id)
        response.tenantId = body.tenant_id;
    if (body.client_id)
        response.clientId = body.client_id;
    if (body.user_id)
        response.userId = body.user_id;
    return response;
}   